<ng-container *ngIf="!isAuthRoute">
  <app-top-panel></app-top-panel>
  <app-left-panel></app-left-panel>
  <div
    class="wrapper d-flex flex-column"
    [ngClass]="{
      'sidebar-unexpanded': !systemService.isSidebarExpanded,
      'sidebar-expanded': systemService.isSidebarExpanded,
    }"
  >
    <div class="body flex-grow-1">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isAuthRoute">
  <router-outlet></router-outlet>
</ng-container>

<br /><br />
<!--systemService.SELECTED_PROJECT_ID:-->
<!--{{ JSON.stringify(systemService.SELECTED_PROJECT_ID) }}-->
<!--systemService.SELECTED_COMPANY_ID:-->
<!--{{ JSON.stringify(systemService.SELECTED_COMPANY_ID) }}-->
<!--systemService.projectsListOptions:-->
<!--{{ JSON.stringify(systemService.projectsListOptions) }}-->
<!--<br>-->
<!--systemService.companiesListOptions:-->
<!--{{ JSON.stringify(systemService.companiesListOptions) }}-->
<!--<br>-->
<!--<br>-->
